/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { isEmpty } from '@ember/utils';
import EventAttributeCondition from 'cio/app-models/conditions/event-attribute';
import { ConditionType } from 'cio/utils/condition-types';
import { EventArgs } from 'cio/components/campaigns/trigger/setup/condition-blocks/event/config';

export default class ConditionBlockEvent extends Component<EventArgs> {
  get highlight() {
    return !this.hasEvent;
  }

  get hasEvent() {
    return !isEmpty(this.args.event);
  }

  get eventFiltersCount() {
    return (this.args.attributeFilters.children as EventAttributeCondition[]).filter(
      ({ type }) => type === ConditionType.EventAttribute,
    ).length;
  }
}
